import {Component, OnInit} from '@angular/core';
import {Product} from '@services/model/product';
import {VoteWithProduct} from '@services/model/vote-with-product';
import {StatsService} from '@services/stats.service';
import moment from 'moment';
import {HpOverviewStats} from '@services/model/hp-overview-stats';
import {SearchproductService} from '@services/searchproduct.service';
import {dasTeamText} from '@dashboard/welcome/welcome.component';
import {MarkantElementsModule} from '@markant/elements-angular';
import {RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';
import {NewProductsComponent} from '@hp-dashboard/hp-welcome/new-products/new-products.component';
import {MomentPipe} from '@util/pipes/moment-pipe';
import {RouteBuilder} from '@util/route-builder';

@Component({
  selector: 'app-hp-welcome',
  templateUrl: './hp-welcome.component.html',
  styleUrls: ['./hp-welcome.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, RouterLink, NewProductsComponent, MomentPipe],
})
export class HpWelcomeComponent implements OnInit {
  stats: HpOverviewStats;
  products: Product[] = [];
  votes: VoteWithProduct[] = [];
  public dasTeamText = dasTeamText;

  constructor(
    private readonly stastService: StatsService,
    private readonly searchproductService: SearchproductService,
  ) {}

  get votingRoute(): string {
    return RouteBuilder.app().hpDashboard().voting().build();
  }

  ngOnInit() {
    this.stastService.getHpOverviewStats().subscribe((stats) => (this.stats = stats));
  }

  get votePassedPercentage(): number {
    if (!this.stats || !this.stats.voting || !this.stats.voting.current) {
      return 0;
    }
    const c = this.stats.voting.current;
    const totalDays = moment.duration(c.votingEnd.diff(c.votingStart)).asDays();
    const passedDays = moment.duration(moment(new Date()).diff(c.votingStart)).asDays();
    return Math.floor((passedDays / totalDays) * 100);
  }

  get remainingDaysToVote(): number {
    if (!this.stats || !this.stats.voting) {
      return 0;
    }
    const c = this.stats.voting.current;
    if (!c) {
      return 0;
    }
    const now = moment(new Date());
    const days = moment.duration(c.votingEnd.diff(now)).asDays();
    return Math.floor(days);
  }

  get showProgressBar(): boolean {
    if (!this.stats || !this.stats.voting || !this.stats.voting.current) {
      return false;
    }
    const c = this.stats.voting.current;
    const now = moment();
    /* this should always evaluate to true, ignoring network latency/reloading differences */
    return now.isBetween(c.votingStart, c.votingEnd);
  }
}
